import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledTextarea = styled(Ds.Textarea)`
    overflow: hidden;
`;

export const StyledBox = styled(Ds.Box)`
    border-left: 4px solid var(--ds-color-silver);
    padding-left: 1rem;
    margin-left: 0.4rem;
`;

export const StyledSelectWrapper = styled.div`
    margin-bottom: 1rem;
    margin-top: 0.25rem;
`;

export const StyledFormField = styled(Ds.Form.Field)`
    margin-bottom: 1rem;
`;
